import React from 'react';
import { Button, Tooltip, Badge } from "antd"
import { PaperClipOutlined } from "@ant-design/icons"
import useStyles from "hooks/useStyles";

const AdjuntosButton = ({ onClick, count, sizeBadge, title, ...rest }) => {
  const { colorPrimary } = useStyles();

  return (
    <Tooltip title={title || "Ver"} mouseLeaveDelay={0}>
      <Badge count={count} size={sizeBadge ?? rest.size}>
        <Button
          icon={<PaperClipOutlined />}
          type="text"
          size="large"
          style={{ color: colorPrimary }}
          onClick={onClick}
          {...rest}
        />
      </Badge>
    </Tooltip>
  );
};

export default AdjuntosButton;